module.exports = "/assets/sample4-04e052974c63025b817335aa3dee04b2.jpg";